import React from 'react';
import CommonSlider from './partials/commonslider';
import { useContactForm } from '../hooks/useContactForm';

const Contact = () => {
  const { formData, loading, success, error, handleChange, handleSubmit } = useContactForm();

  return (
    <main className="petti_f_bg">
      <CommonSlider />

      <div className="container margin_80_55">
        <div className="row justify-content-between">
          <div className="col-xl-4 col-lg-5 order-lg-2 desktopview">
            <div className="contact_info">
              <ul className="clearfix">
                <li>
                  <i className="bi bi-clock"></i>
                  <h4>Working Hours</h4>
                  <div>Monday to Saturday 8am - 10.30pm<br />Sunday 8am - 11.30pm</div>
                </li>
                <li>
                  <i className="bi bi-geo-alt"></i>
                  <h4>Address</h4>
                  <div>17, Bandaramulla<br />Mirissa</div>
                </li>
                <li>
                  <i className="bi bi-envelope-paper"></i>
                  <h4>Email address</h4>
                  <p>
                    <a href="mailto:reservations@oryzaleisure.com">reservations@oryzaleisure.com</a>
                  </p>
                </li>
                <li>
                  <i className="bi bi-telephone"></i>
                  <h4>Telephone</h4>
                  <div>
                    <a href="tel:+94761407881">+ 94 76 140 7881</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-xl-7 col-lg-7 order-lg-1 col-12">
            <h2 className="mb-3" style={{ color: '#ebdbcc' }}>Get in Touch</h2>
            <div id="message-contact"></div>
            <form onSubmit={handleSubmit} id="contact" autoComplete="off">
              <div className="row">
                <div className="col-sm-12 col-12">
                  <div className="form-floating mb-4">
                    <input
                      className="form-control"
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                    <label htmlFor="name_contact">Name*</label>
                  </div>
                </div>
                <div className="col-sm-12 col-12">
                  <div className="form-floating mb-4">
                    <input
                      className="form-control"
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                    <label htmlFor="lastname_contact">Email*</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-12">
                  <div className="form-floating mb-4">
                    <input
                      className="form-control"
                      type="tel"
                      id="mobile"
                      name="mobile"
                      placeholder="Telephone"
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                    />
                    <label htmlFor="phone_contact">Telephone*</label>
                  </div>
                </div>
              </div>
              <input type="hidden" name="hotel" id="hotel" value="pettipetti" />
              <div className="form-floating mb-4">
                <textarea
                  className="form-control"
                  placeholder="Message"
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
                <label htmlFor="message_contact">Message*</label>
              </div>
              {success && (
                <div id="success" className="message success" style={{ display: 'block', backgroundColor: 'green', padding: '10px', color: '#ffffff', margin: '10px 0', borderRadius: '5px' }}>
                  Your message has been successfully sent!
                </div>
              )}
              
              {error && (
                <div className="message error" style={{ backgroundColor: 'red', padding: '10px', color: '#ffffff', margin: '10px 0', borderRadius: '5px' }}>
                  {error}
                </div>
              )}
              
              <p className="mt-3">
                <input
                  type="submit"
                  value={loading ? 'Sending...' : 'Submit'}
                  className="btn_1 outline_cream"
                  id="submit-contact"
                  disabled={loading}
                />
              </p>
            </form>
          </div>
          <div className="col-xl-4 col-lg-5 order-lg-2 col-12 mobileview">
            <div className="contact_info">
              <ul className="clearfix">
                <li>
                  <i className="bi bi-clock"></i>
                  <h4>Working Hours</h4>
                  <div>Monday to Saturday 8am - 10.30pm<br />Sunday 8am - 11.30pm</div>
                </li>
                <li>
                  <i className="bi bi-geo-alt"></i>
                  <h4>Address</h4>
                  <div>17, Bandaramulla<br />Mirissa</div>
                </li>
                <li>
                  <i className="bi bi-envelope-paper"></i>
                  <h4>Email address</h4>
                  <p>
                    <a href="mailto:reservations@oryzaleisure.com">reservations@oryzaleisure.com</a>
                  </p>
                </li>
                <li>
                  <i className="bi bi-telephone"></i>
                  <h4>Telephone</h4>
                  <div>
                    <a href="tel:+94761407881">+ 94 76 140 7881</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="map_contact">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31746.71770504043!2d80.43351255550016!3d5.9478382683381215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae13faa0c4accab%3A0x85a3a5f3c8de543c!2sPetti%20Petti%20Mirissa!5e0!3m2!1sen!2slk!4v1708385880174!5m2!1sen!2slk"
          width="600"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Petti Petti Mirissa Location"
        ></iframe>
      </div>
    </main>
  );
};

export default Contact;
